import React from "react";
import { AutoBind } from "../../rule-engine-core/Common/AutoBind";
import { DataUtilities } from "../../rule-engine-core/Common/DataUtilities";
import { StateManager } from "../../rule-engine-core/Common/StateManager";

/**
 <ObserveState
 listenTo={anobject}
 control={() => {
        return (

        );
    }}
 />


 **/

// export const ObserveState: React.FC<{
//     listenTo: object | null | undefined;
//     control: () => JSX.Element | React.ReactNode;
//     properties?: string[];
// }> = ({ listenTo, control, properties }) => {
//     let [_render, setRender] = useReducer((x) => x + 1, 0);
//     let [id, setId] = useState<string>();
//
//     useEffect(() => {
//         let observerId = id;
//         if (!observerId) {
//             observerId = DataUtilities.generateUniqueId();
//             setId(observerId);
//         }
//
//         if (listenTo && listenTo !== null)
//             StateManager.addObserver(
//                 listenTo,
//                 () => {
//                     console.log("rerender");
//                     setRender();
//                 },
//                 properties,
//                 observerId
//             );
//
//         return function cleanup() {
//             if (listenTo && listenTo !== null) StateManager.removeObserverByName(listenTo, id!);
//         };
//     }, [listenTo, properties]);
//
//     return <>{control()}</>;
// };

export class ObserveState extends React.Component<{
    listenTo: object | null | undefined;
    control: () => JSX.Element | React.ReactNode;
    properties?: string[];
    onWillUnmount?: () => void;
}> {
    render() {
        return this.props.control();
    }

    componentDidMount() {
        if (this.props.listenTo) StateManager.addObserver(this.props.listenTo, this, this.props.properties || []);
    }

    componentDidUpdate(prevProps: {
        listenTo: object | null | undefined;
        control: () => JSX.Element | React.ReactNode;
        properties?: string[];
        onWillUnmount?: () => void;
    }) {
        if (prevProps.listenTo !== this.props.listenTo) {
            if (prevProps.listenTo) StateManager.removeObserver(prevProps.listenTo, this);

            if (this.props.listenTo) StateManager.addObserver(this.props.listenTo, this, this.props.properties || []);
        }
    }

    componentWillUnmount() {
        if (this.props.listenTo) StateManager.removeObserver(this.props.listenTo, this);

        if (this.props.onWillUnmount) {
            this.props.onWillUnmount();
        }
    }

    @AutoBind
    update() {
        this.setState({ key: DataUtilities.generateUniqueId() });
        this.forceUpdate();
    }
}
